import { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#" className="nav-logo">
          <img src="/icon.png" alt="SyncroX" className="nav-logo-img" />
          <img src="/logo_light2.png" alt="SyncroX" className="nav-logo-wordmark" />
        </a>
        <ul className="nav-links">
          <li><a href="#problem">Proč SyncroX</a></li>
          <li><a href="#solutions">Řešení</a></li>
          <li><a href="#integrations">Integrace</a></li>
          <li><a href="#pricing">Ceník</a></li>
          <li><a href="#cta" className="nav-cta">Bezplatná konzultace &rarr;</a></li>
        </ul>
      </div>
    </nav>
  );
}
